import { useCallback } from 'react';
import { API } from '../../helpers';
import useKeyOptionsQueryV1110 from '../CommercialV106/useKeyOptionsQueryV1110';
import { keyOptionsConfigV1110 } from '../CommercialV106/useKeyCommercialOptionsV1110';

export default function useKeyModelOptionsV1013(policy, targetUserId, enabled) {
  const manual = policy?.strategy === 'manual';
  // Preview the policy that dispatch will actually enforce.
  const draft = {
    strategy: policy?.strategy || 'inherit',
    channel_ids: policy?.channel_ids,
    maximum_multiplier: policy?.maximum_multiplier,
    offer_id: policy?.offer_id,
    ...(manual
      ? {
          source_refs: policy.source_refs || [],
        }
      : {}),
    group_restriction_enabled: Boolean(policy?.group_restriction_enabled),
    allowed_groups: policy?.group_restriction_enabled
      ? policy.allowed_groups || []
      : [],
  };
  const missingSource =
    manual && !draft.source_refs.length && !draft.channel_ids?.length;
  const missingGroup =
    draft.group_restriction_enabled && !draft.allowed_groups.length;
  const request = JSON.stringify({
    user_id: Number(targetUserId) || 0,
    commercial_policy_v106: draft,
  });
  const load = useCallback(async (signal) => {
    const response = await API.post('/api/user/key-model-options', JSON.parse(request), keyOptionsConfigV1110(signal));
    const data = response?.data;
    if (!data?.success || !Array.isArray(data.data) || data.data.some((name) => typeof name !== 'string')) {
      throw new Error('Invalid model options');
    }
    return [...new Set(data.data)];
  }, [request]);
  const result = useKeyOptionsQueryV1110(request, enabled && !missingSource && !missingGroup, load);
  const ready = result.ready;
  return {
    models: ready ? result.data : [],
    loading: result.loading,
    error: Boolean(result.error),
    ready,
    missingSource,
    missingGroup,
    retry: result.retry,
  };
}
